import TerminationAlert from './TerminationAlert';

export default TerminationAlert;
